// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"f985ed168877286b947e","678":"1654efbb60bd3031456e","883":"28011e3d933b2e6aaaf2"}[chunkId] + ".js";
};